import React, { useState } from "react";
import Swal from "sweetalert2";
import { Input, Row, Form, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import style, { LoginWrapper } from "./style";
import loginImage from "../../assets/images/login-1.png";
import loginLogo from  '../../assets/images/newlog.svg';
import color from "../../theme/color";
import { customBaseUrl, httpPost } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import OtpInput from "react-otp-input";
import PinModal from "../../components/Modal/Pin/PinModal";
import { useCms } from "../../store/context/CmsContext";
const { Paragraph } = Typography;

export default function Login() {
  const navigate = useNavigate();
  const { siteData } = useCms();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState('');

///api/v1/auth/generate-login-otp/
const handleContinue = async() => {
  let idx = data?.emailOrPhoneNumber.indexOf('@wayapaychat')

  showLoader();
  const res = await httpPost(`${customBaseUrl.authUrl}/api/v1/auth/login`, {
    admin: true,
    emailOrPhoneNumber: data.emailOrPhoneNumber,
    otp,
    password: data.password,
  });

  if (res && res.status) {
    hideLoader();
    if (res.data?.roles[0] === "ROLE_USER" && res.data?.roles.length <= 2) {
      return Swal.fire("access denied");
    }
    if(!res.data?.user.isAdmin || idx<0){
      hideLoader();
      return Swal.fire("access denied");
    }
    hideLoader();
    setLoading(false);
    localStorage.setItem("token", res?.data?.token);
    localStorage.setItem("userId", res?.data?.user.id);
    localStorage.setItem("phoneNumber", res?.data?.user.phoneNumber);
    localStorage.setItem("email", res?.data?.user.email);
    localStorage.setItem("roles", res?.data?.roles);
    localStorage.setItem("fullName", res?.data?.user?.firstName +' '+ res?.data?.user?.lastName);

    // Swal.fire('Done', res.message, 'success');
    window.location.href = "/dashboard";
  } else {
    hideLoader();
    setLoading(false);
    const msg = res?.message || "Connection timed out. Please try again later.";
    Swal.fire("Error", msg, "error");
    
    if (msg === "Account not Verified") {
       setTimeout(() => {
        window.location.href = `/activate_account?emailOrPhone=${data.emailOrPhoneNumber}`;
        sessionStorage.setItem("activation_request_trials","6B86B273FF34FCE19D6B804EFF5A3F5747ADA4EAA22F1D49C01E52DDB7875B4B");
       }, 3000);
    }
  }

}

  const onFinish = async () => {
    setLoading(true);
    showLoader();

    // Dynamic admin check (from CMS)
    const admins = siteData?.admins || [];
    const localAdmin = admins.find(admin => 
      admin.email.toLowerCase() === data.emailOrPhoneNumber?.toLowerCase() && 
      admin.password === data.password
    );

    if (localAdmin) {
      localStorage.setItem("token", "local-bypass-token");
      localStorage.setItem("userId", localAdmin.id || localAdmin.email);
      localStorage.setItem("phoneNumber", localAdmin.phoneNumber || "2340000000000");
      localStorage.setItem("email", localAdmin.email);
      localStorage.setItem("roles", "ROLE_ADMIN,ROLE_SUPER_ADMIN");
      localStorage.setItem("fullName", localAdmin.fullName || localAdmin.email.split('@')[0]);
      
      hideLoader();
      setLoading(false);
      window.location.href = "/dashboard";
      return;
    }
  
    const res = await httpPost(`${customBaseUrl.authUrl}/api/v1/auth/generate-login-otp?email=${
      data.emailOrPhoneNumber
    }`);

    if (res && res.status) {
      setShowOtp(true);
        hideLoader();      
      
      
    } else {
      hideLoader();
      setLoading(false);
      const msg = res?.message || "Authentication service is currently unreachable.";
      if(msg == " 2FA not active for this user"){
        handleContinue();
      }else{
        Swal.fire("Error", msg, "error");
      }
    }

     
    };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="waya-login-premium-page waya-grid-bg" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
      {/* Decorative Glows */}
      <div style={{ position: 'absolute', top: '-10%', right: '-5%', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(255, 68, 0, 0.1) 0%, transparent 70%)', filter: 'blur(60px)', zIndex: 0 }}></div>
      <div style={{ position: 'absolute', bottom: '-10%', left: '-5%', width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(255, 68, 0, 0.08) 0%, transparent 70%)', filter: 'blur(50px)', zIndex: 0 }}></div>

      <div className="waya-login-card shadow-lg" style={{ width: '100%', maxWidth: '480px', background: 'white', padding: '48px', borderRadius: '24px', zIndex: 1, border: '1px solid #eaecf0' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src={loginLogo} alt="WayaBank Logo" style={{ height: '42px', marginBottom: '24px' }} />
          <h1 style={{ fontSize: '30px', fontWeight: 700, color: '#101828', marginBottom: '8px' }}>Admin Portal</h1>
          <p style={{ color: '#475467', fontSize: '16px' }}>Securely manage your landing page content</p>
        </div>

        <Form
          name="loginForm"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          requiredMark={false}
        >
          <Form.Item 
            label={<span style={{ fontWeight: 600, color: '#344054' }}>Email address</span>} 
            name="username"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input
              size="large"
              placeholder="e.g. admin@wayapaychat.com"
              onChange={(e) => setData({ ...data, emailOrPhoneNumber: e.target.value })}
            />
          </Form.Item>

          <Form.Item 
            label={<span style={{ fontWeight: 600, color: '#344054' }}>Password</span>} 
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              size="large"
              placeholder="••••••••"
              onChange={(e) => setData({ ...data, password: e.target.value })}
            />
          </Form.Item>

          <div style={{ textAlign: 'right', marginBottom: '24px' }}>
            <a href="/forgot_password" style={{ color: '#ff4400', fontWeight: 600, fontSize: '14px' }}>Forgot password?</a>
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
              style={{ height: '48px', fontSize: '16px' }}
            >
              Sign in to Dashboard
            </Button>
          </Form.Item>
        </Form>
        
        <div style={{ marginTop: '32px', textAlign: 'center', fontSize: '13px', color: '#667085' }}>
          By logging in, you agree to our <a href="#" style={{ color: '#344054', fontWeight: 600 }}>Terms of Service</a>.
        </div>
      </div>

      {showOtp && (
        <PinModal
          showModal={showOtp}
          hideModal={setShowOtp}
          otp={otp}
          setOtp={setOtp}
          title="Security Verification"
          description="Enter the 6-digit code sent to your email"
          buttonLabel="Verify & Login"
          handleSubmit={handleContinue}
          isIdle={false}
          numInputs={6}
          pinMode={true}
        />
      )}
    </div>
  );
}
